import React from "react";

import { ContentGroupPreviewBar } from "./content-group-preview-bar";

class ContentGroupPreview extends React.PureComponent {
  static get propTypes() {
    return {
      ...ContentGroupPreviewBar.propTypes,
    };
  }

  static get defaultProps() {
    return {
      ...ContentGroupPreviewBar.defaultProps,
    };
  }

  render() {
    const { index, mediaEntries, navigateTo } = this.props;
    const total = mediaEntries.length;

    return (
      <div className="content-group-preview">
        <ContentGroupPreviewBar
          index={index}
          navigateTo={navigateTo}
          mediaEntries={mediaEntries}
        />
        <div className="cg-count">{`${index + 1}/${total}`}</div>
      </div>
    );
  }
}

export { ContentGroupPreview };
